import React from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import styled from "styled-components";

import Form from "./password change component/Form";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e5cce200;
  height: 100%;
  padding: 0 30px;
`;

export default function ResetChangePassword() {
  const params = useParams();
  const code = params.code || "";

  return (
    <Wrapper>
      <Helmet title="Forgot Password" />
      <Form code={code} />
    </Wrapper>
  );
}
